require('./dist/dataGrid');
require('./dist/pagination');

module.exports = {
    dataGrid: 'dataGrid',
    pagination: 'pagination',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-data-grid/index.js
// module id = 2063
// module chunks = 2